import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { CardSpacing } from '../Card/Card';
import { NestedCardVariant } from './types';

export interface NestedCardProps {
    variant?: NestedCardVariant;
    padding?: CardSpacing;
    fill?: boolean;
    overflowHidden?: boolean;
}

const getBackgroundColor = (variant?: NestedCardVariant) => {
    switch (variant) {
        case 'default':
            return 'transparent';
        case 'subtle':
            return getToken('backgroundInteractiveNeutralDefault');
        case 'highlighted':
            return getToken('backgroundInteractiveSecondaryDefault');
        default:
            return 'transparent';
    }
};

const getBorderColor = (variant?: NestedCardVariant) => {
    switch (variant) {
        case 'default':
            return getToken('borderStaticPrimary');
        case 'subtle':
            return getToken('backgroundInteractiveNeutralDefault');
        case 'highlighted':
            return getToken('backgroundInteractiveSecondaryDefault');
        default:
            return getToken('borderStaticPrimary');
    }
};

/** @deprecated Use the Card component */
const NestedCard = styled.div<NestedCardProps>`
    box-sizing: border-box;
    ${({ padding }) =>
        padding &&
        css`
            padding: ${getSpacingToken(padding)}px;
        `}
    border-radius: ${getToken('borderRadius100')}px;
    ${({ variant }) => css`
        background-color: ${getBackgroundColor(variant)};
    `}
    ${({ overflowHidden }) => overflowHidden && `overflow: hidden;`}
    ${({ variant }) => css`
        border: ${getToken('borderWidth100')}px solid ${getBorderColor(variant)};
    `}
    ${({ fill }) =>
        fill &&
        css`
            height: 100%;
        `}
`;

NestedCard.defaultProps = {
    variant: 'default',
    padding: '200',
};

export default NestedCard;
